import React from "react";

const ShimmerBlock = ({ className }) => (
  <div className={`shimmer rounded ${className}`} />
);

const EditServiceShimmer = () => {
  return (
    <section className="relative max-w-7xl mx-auto px-4 md:px-6 py-10">
      {/* Header */}
      <div className="flex items-center justify-between bg-white px-6 py-4 rounded-2xl shadow-sm mb-10">
        <ShimmerBlock className="h-8 w-8 rounded-full" />
        <ShimmerBlock className="h-6 w-64" />
        <div className="w-10" />
      </div>

      {/* Main Card */}
      <div className="bg-white rounded-3xl shadow-sm border px-6 sm:px-8 py-8 max-w-6xl mx-auto space-y-10">
        {/* Service Name */}
        <ShimmerBlock className="h-12 w-full max-w-xl" />

        {/* Upload heading */}
        <ShimmerBlock className="h-5 w-72" />

        {/* Upload Card */}
        <ShimmerBlock className="h-40 w-full rounded-2xl" />

        {/* Image previews */}
        <div className="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-6 gap-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <ShimmerBlock key={i} className="h-24 w-full rounded-xl" />
          ))}
        </div>

        {/* Description */}
        <ShimmerBlock className="h-24 w-full" />

        {/* Toggle */}
        <ShimmerBlock className="h-14 w-full rounded-lg" />

        {/* Currency + Timezone */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <ShimmerBlock className="h-12 w-full" />
          <ShimmerBlock className="h-12 w-full" />
        </div>

        {/* Time pickers */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <ShimmerBlock className="h-16 w-full" />
          <ShimmerBlock className="h-16 w-full" />
        </div>

        {/* Save button */}
        <ShimmerBlock className="h-12 w-40 rounded-xl" />
      </div>
    </section>
  );
};

export default EditServiceShimmer;
